import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LoggerService} from "../../../../core/logger.service";
import {BusinessHoursDto, PointOfSaleDto} from "../../point-of-sale-dto";

@Component({
    selector: 'business-hours',
    templateUrl: './business-hours.component.html',
    providers: []
})
export class BusinessHoursComponent implements OnInit{

    @Input() dto:PointOfSaleDto;
    @Input() isEditing:boolean = false;
    @Input() errors;
    @Input() errorMessages;
    @Input() data;
    bhValidations:any={valid:true, errors:{}};

    constructor(private logger: LoggerService, private translate: TranslateService) {
        logger.info('BusinessHoursComponent: logger.info()');
    }

    ngOnInit(): void {
    }

    addBusinessHour(){
        this.bhValidations = this.isBhValid();
        if(this.bhValidations.valid){
            Object.keys(this.dto.days)
                .filter(k => this.dto.days[k])
                .forEach(k => {
                    let index = this.dto.businessHours.findIndex(bh => bh.dayOfWeek == k);
                    if(index != -1){
                        this.dto.businessHours.splice(index, 1);
                    }
                    this.dto.businessHours.push(new BusinessHoursDto(k,this.formatedHour(this.dto.hourFrom),
                        this.formatedHour(this.dto.hourTo), this.formatedHour(this.dto.hourFrom2),
                        this.formatedHour(this.dto.hourTo2)));
                });
        }
    }

    private formatedHour(hour){
        if(hour === '24:00') return '23:59';
        else if(!!hour) return hour;
        else null;
    }

    private getFormatedHour(hour){
        if(hour === '23:59')
            return '24:00';
        return hour;
    }

    checkAll(event) {
        this.updateValidations();
        for (let day in this.data.days) {
            this.dto.days[this.data.days[day].id] = (event.detail === 0); //When event.detail is 0 all days goes checked otherwise goes unchecked
        }
    }

    updateValidations():void{
        let keyErrors = Object.keys(this.bhValidations.errors);
        for (let prop of keyErrors) {
            this.bhValidations.errors[prop] = null;
        }

    }

    isBhValid(){
        let isValid = true;
        let errors = {};
        if(!(Object.keys(this.dto.days).some(k => this.dto.days[k]))){
            isValid = false;
            errors['days'] = 'common.error.REQUIRED';
        }

        if(!this.dto.hourFrom || !this.dto.hourTo || (this.dto.hourFrom>=this.dto.hourTo)){
            isValid = false;
            errors['hours1'] = 'common.error.REQUIRED';
        }

        if(!!this.dto.hasSecondTime && (!this.dto.hourFrom2 || !this.dto.hourTo2 || (this.dto.hourFrom2>=this.dto.hourTo2))){
            isValid = false;
            errors['hours2'] = 'common.error.REQUIRED';
        }
        return  {valid:isValid, errors:errors};
    }

    removeBusinessHour(day){
        let index = this.dto.businessHours.findIndex(bh => bh.dayOfWeek == day);
        if(index != -1){
            this.dto.businessHours.splice(index, 1);
        }
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/business-hours/business-hours.component.ts